var StoreSelectorTagNameEnum;
(function (StoreSelectorTagNameEnum) {
    StoreSelectorTagNameEnum["button"] = "SKAPA-BUTTON";
    StoreSelectorTagNameEnum["hyperlink"] = "KOMPIS-HYPERLINK";
})(StoreSelectorTagNameEnum || (StoreSelectorTagNameEnum = {}));
export default StoreSelectorTagNameEnum;
//# sourceMappingURL=StoreSelectorTagNameEnum.js.map